import React from 'react';
import { ChevronLeft, ChevronRight } from '@yme/assets/icons';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { PDP_TYPE, PAGE_TYPE, CLP_TYPE, PLP_TYPE, VARIANTS_ACCESSORY_TYPE_EN, VARIANTS_COLLECTION, QueryParams, } from '@yme/common/constants';
import { SubMenu } from '@yme/components/Header/Megamenu/SubMenu';
import { CMP_LINK_QUERIES, DiscountedFilterValue } from '@yme/components/Header/Megamenu/constants';
import { MenuUnitCard } from '@yme/components/Header/MenuUnitCard';
import { EXTRA_MENU_TYPE } from '@yme/components/Header/constants';
import { Link } from '@yme/components/Link';
import { FacetFields } from '@yme/utils/bloomreach';
import { noop } from '@yme/utils/common';
import { POWER_VERSION_35KW, YAMT } from '@yme/utils/constants';
import { FilterType } from './constants';
import { UnitWrapperStyled } from './styled';
export const getIsYAMTIconShowed = (product) => {
    const isYAMTTransmission = product?.productMotorcycleTransmissionEn === YAMT;
    const isSomeOfVariationsHasYAMTTransmission = product?.groupingProducts?.some((item) => item?.productMotorcycleTransmissionEn === YAMT);
    return isYAMTTransmission || isSomeOfVariationsHasYAMTTransmission;
};
export const getIs35KWIconShowed = (product) => {
    const is35KWPowerVersion = product?.productMotorcyclePowerVersionEn === POWER_VERSION_35KW;
    const isSomeOfVariationsHas35KWPowerVersion = product?.groupingProducts?.some((item) => item?.productMotorcyclePowerVersionEn === POWER_VERSION_35KW);
    return is35KWPowerVersion || isSomeOfVariationsHas35KWPowerVersion;
};
export function createSubMenu(childPages, isRightToLeft, type, closeMenuHandler, driverLicenseLabel, navProducts, isDriverLicenseEnabled = false, isImageFullWidth = false, parentLink, menuTitle, label, inRiverId = '', isExtraMenuActive = false, hasExtraMenuTitle = false, isTwoLevelsView = false) {
    const currentChevronIcon = isRightToLeft ? ChevronLeft : ChevronRight;
    const currentChildren = type === PLP_TYPE ? navProducts : childPages;
    const PDPData = childPages?.find(({ pageType }) => pageType === PDP_TYPE);
    const isExtraMenuExists = type === EXTRA_MENU_TYPE;
    const subMenuTitle = hasExtraMenuTitle ? menuTitle : `${label} ${menuTitle}`;
    if (type === PLP_TYPE && navProducts && navProducts[inRiverId]?.length) {
        return (React.createElement(SubMenu, { isRightToLeft: isRightToLeft, closeMenuHandler: closeMenuHandler, isExtraMenuActive: isExtraMenuActive, title: subMenuTitle, link: parentLink || '', menuType: type, isUnitSubmenu: true }, navProducts[inRiverId]?.map((product) => {
            const isYAMTIconShowed = getIsYAMTIconShowed(product);
            const is35KWIconShowed = getIs35KWIconShowed(product);
            return (React.createElement(UnitWrapperStyled, { key: product.key },
                React.createElement(MenuUnitCard, { product: product, isYAMTIconShowed: isYAMTIconShowed, is35KWIconShowed: is35KWIconShowed, unitPath: PDPData?.link ?? '', isDriverLicenseEnabled: isDriverLicenseEnabled, label: driverLicenseLabel || '', isImageFullWidth: isImageFullWidth, closeMenuHandler: closeMenuHandler || noop })));
        })));
    }
    if (type === CLP_TYPE && navProducts) {
        return currentChildren?.length ? (React.createElement(SubMenu, { isRightToLeft: isRightToLeft, menuType: type, closeMenuHandler: closeMenuHandler, title: menuTitle || '', link: parentLink || '' }, Array.isArray(currentChildren) &&
            currentChildren?.map(({ title, childPages: itemChildPages, link, onClick, pageType, inRiverId: itemInRiverId, isImageFullWidth: isFullWidth, hasExtraMenuTitle, }) => itemChildPages?.length ? (React.createElement("li", { key: title },
                React.createElement("span", null, title),
                React.createElement(SVGIcon, { type: currentChevronIcon, size: ICON_SIZE.xs }),
                childPages.length
                    ? createSubMenu(itemChildPages, isRightToLeft, pageType, closeMenuHandler, driverLicenseLabel, navProducts, isDriverLicenseEnabled, isFullWidth, link, title, label, itemInRiverId, isExtraMenuExists, hasExtraMenuTitle)
                    : null)) : (React.createElement("li", { key: title },
                React.createElement("span", null,
                    React.createElement(Link, { to: link, onClick: () => onClick(link) }, title))))))) : null;
    }
    if (isTwoLevelsView) {
        return (React.createElement(SubMenu, { menuType: type, closeMenuHandler: closeMenuHandler, title: menuTitle || '', link: parentLink || '', isRightToLeft: isRightToLeft }, Array.isArray(currentChildren) &&
            currentChildren?.map(({ title, link, onClick }) => (React.createElement("li", { key: title },
                React.createElement("span", null,
                    React.createElement(Link, { to: link, onClick: () => onClick(link) }, title)))))));
    }
    return currentChildren?.length ? (React.createElement(SubMenu, { menuType: type, closeMenuHandler: closeMenuHandler, title: menuTitle || '', link: parentLink || '', isRightToLeft: isRightToLeft }, Array.isArray(currentChildren) &&
        currentChildren?.map(({ title, childPages: itemChildPages, link, pageType, onClick, inRiverId: itemInRiverId, isImageFullWidth: isFullWidth, hasExtraMenuTitle, }) => itemChildPages?.length ? ((Boolean(itemInRiverId && navProducts && navProducts[itemInRiverId]?.length) ||
            pageType === PAGE_TYPE) && (React.createElement("li", { key: title },
            React.createElement("span", null, title),
            React.createElement(SVGIcon, { type: currentChevronIcon, size: ICON_SIZE.xs }),
            childPages.length
                ? createSubMenu(itemChildPages, isRightToLeft, pageType, closeMenuHandler, driverLicenseLabel, navProducts, isDriverLicenseEnabled, isFullWidth, link, title, label, itemInRiverId, isExtraMenuExists, hasExtraMenuTitle)
                : null))) : (React.createElement("li", { key: title },
            React.createElement("span", null,
                React.createElement(Link, { to: link, onClick: () => onClick(link) }, title))))))) : null;
}
export const getCMPlProductLink = (link, filter, value) => {
    const searchParams = new URLSearchParams();
    const { filterKey } = CMP_LINK_QUERIES;
    if (filter && value) {
        searchParams.set(filter, value);
    }
    const query = searchParams.toString();
    const finalQuery = query.replace(`${filterKey}=`, '').replace('%3D', '=');
    return query ? `${link}?${finalQuery}` : link;
};
export const getFilter = (filterType, isBloomreachSource) => {
    switch (filterType) {
        case FilterType.ACCESSORY_TYPE:
            return isBloomreachSource ? FacetFields.TYPE_EN : VARIANTS_ACCESSORY_TYPE_EN;
        case FilterType.COLLECTION:
            return isBloomreachSource ? FacetFields.COLLECTION : VARIANTS_COLLECTION;
        case FilterType.IS_DISCOUNTED:
        default:
            return isBloomreachSource ? FacetFields.IS_DISCOUNTED : QueryParams.DISCOUNTED;
    }
};
export const getFilterValue = (filterType, value, isBloomreachSource) => {
    if (filterType === FilterType.IS_DISCOUNTED) {
        return getDiscountedFilterValue(value, isBloomreachSource);
    }
    return value;
};
const getDiscountedFilterValue = (value, isBloomreachSource) => {
    if (value === DiscountedFilterValue.YES) {
        return isBloomreachSource ? '1' : 'true';
    }
    return '';
};
